import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { FormattedMessage } from "react-intl";
import "./ProductView.scss";
class ProductView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <div
        className="product-view-a5"
        style={{
          backgroundColor: "#f8f9fa",
          padding: "20px 0",
          marginTop: 10,
          marginBottom: 40,
          borderRadius: 15,
        }}
      >
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h2 className="title-product-a5">
              <FormattedMessage id="product.a5.product-view.a1" />
            </h2>
            <div
              style={{
                background: "white",
                borderRadius: 15,
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                padding: 20,
                maxWidth: 1200,
                margin: "0 auto",
              }}
            >
              <iframe
                ref={this.iframeRef}
                src="/static/web/a5/a5.html"
                width="100%"
                // height="700px"
                allowFullScreen
                allow="fullscreen"
                style={{ border: "none", borderRadius: 10, minHeight: 500 }}
                title="View A5"
              ></iframe>
              <p
                style={{
                  textAlign: "center",
                  marginTop: 15,
                  color: "#666",
                  fontSize: 14,
                }}
              >
                <FormattedMessage id="product.a5.product-view.a2" />
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductView)
);
